// extracted by mini-css-extract-plugin
export default {"dynamicForm":"DynamicForm_dynamicForm__e8Rkq"};